/**
 * Properties and methods relating to the panama user - Previously MMF.User
 */

mmf_modules.define('utils/user',[
    'context_vars/utils/user',
    'utils/utils',
    'utils/settings'
], function (
    context,
    mmf_utils,
    mmf_settings
) {
    'use strict';

    var User = mmf_utils.extend(true, {}, context);

    User.USER_CLASSES = {
        MVP: 'mvp',
        FREE: 'free',
        ANONYMOUS: 'anonymous'
    };

    User.getUserType = function () {
        // simulated mvp for testing
        if (mmf_settings.debug && mmf_utils.QueryString.Get('mvp')) {
            return User.USER_CLASSES.MVP;
        }
        // real mvp
        else if (context.id && context.is_mvp) {
            return User.USER_CLASSES.MVP;
        }
        // there's a user, but no MVP
        else if (context.id) {
            return User.USER_CLASSES.FREE;
        }
        // no user
        else {
            return User.USER_CLASSES.ANONYMOUS;
        }
    };

    return User;
});

